import {
  BrowserRouter,
  Routes,
  Route
}
from "react-router-dom";

import Login
from "../pages/auth/Login";

import Dashboard
from "../pages/dashboard/Dashboard";

import PrivateRoute
from "./PrivateRoute";

import Designs
from "../pages/masters/Designs";
import Material
from "../pages/masters/Material";

import Products
from "../pages/masters/Products";

import Suppliers
from "../pages/masters/Suppliers";

import Customers
from "../pages/masters/Customers";

import CurrentStock
from "../pages/inventory/CurrentStock";


import GRN
from "../pages/inventory/Grn";

import GRNList
from "../pages/inventory/GRNList";

import Productionorders
from "../pages/production/ProductionOrders";

import FinishedGoodsStock
from "../pages/inventory/FinishedGoodsStock";

import Dispatches
from "../pages/dispatch/Dispatches";

import StockLedger
from "../pages/reports/StockLedger";

import ReportDashobard
from "../pages/reports/ReportsDashboard";

import BOMCreate
from "../pages/manufacturing/BOMCreate";

import StockAdjustment
from "../pages/inventory/StockAdjustment";

import SalesOrders
from "../pages/sales/SalesOrders";

import SalesOrderList
from "../pages/sales/SalesOrderList";

import DispatchFromSO
from "../pages/dispatch/DispatchFromSO";


const AppRoutes = () => {

  return(

    <BrowserRouter>

      <Routes>

        <Route
          path="/"
          element={<Login />}
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
  path="/designs"
  element={
    <PrivateRoute>
      <Designs />
    </PrivateRoute>
  }
/>
 <Route
  path="/materials"
  element={
    <PrivateRoute>
      <Material />
    </PrivateRoute>
  }
/>

<Route
  path="/products"
  element={
    <PrivateRoute>
      <Products />
    </PrivateRoute>
  }
/>

<Route
  path="/suppliers"
  element={
    <PrivateRoute>
      <Suppliers />
    </PrivateRoute>
  }
/>

<Route
  path="/customers"
  element={
    <PrivateRoute>
      <Customers />
    </PrivateRoute>
  }
/>

<Route
  path="/inventory"
  element={
    <PrivateRoute>
      <CurrentStock />
    </PrivateRoute>
  }
/>



<Route
  path="/grn"
  element={
    <PrivateRoute>
      <GRN />
    </PrivateRoute>
  }
/>

<Route
  path="/grn-list"
  element={
    <PrivateRoute>
      <GRNList />
    </PrivateRoute>
  }
/>

<Route
  path="/production"
  element={
    <PrivateRoute>
      <Productionorders />
    </PrivateRoute>
  }
/>

<Route
  path="/fg-stock"
  element={
    <PrivateRoute>
      <FinishedGoodsStock />
    </PrivateRoute>
  }
/>

<Route
  path="/dispatch"
  element={
    <PrivateRoute>
      <Dispatches />
    </PrivateRoute>
  }
/>

<Route
  path="/stock-ledger"
  element={
    <PrivateRoute>
      <StockLedger />
    </PrivateRoute>
  }
/>

<Route
  path="/reports"
  element={
    <PrivateRoute>
      <ReportDashobard />
    </PrivateRoute>
  }
/>

<Route
  path="/bom/create"
  element={
    <PrivateRoute>
      <BOMCreate />
    </PrivateRoute>
  }
/>

<Route
  path="/stock-adjustment"
  element={
    <PrivateRoute>
      <StockAdjustment />
    </PrivateRoute>
  }
/>

<Route
  path="/sales-orders"
  element={
    <PrivateRoute>
      <SalesOrders />
    </PrivateRoute>
  }
/>

<Route
  path="/sales-order-list"
  element={
    <PrivateRoute>
      <SalesOrderList />
    </PrivateRoute>
  }
/>

<Route
 path="/dispatch-from-so/:id"
 element={
   <PrivateRoute>
     <DispatchFromSO />
   </PrivateRoute>
 }
/>

      </Routes>

    </BrowserRouter>

  );

};

export default AppRoutes;